<form [formGroup]="form">
  <div class="row">
    <div class="d-flex justify-content-end mt-4">
      <div class="col-sm-8">
        <h2 mat-dialog-title>Add Beneficiary Details</h2>
      </div>
      <div class="col-md-4 mt-4">
        <button
          mat-icon-button
          class="close-button"
          style="margin-right: 35px"
          [mat-dialog-close]="true"
        >
          <mat-icon class="close-icon" color="warn">close</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <mat-dialog-content>
    <div class="row">
      <div class="mb-3">
        <button
          mat-raised-button
          (click)="toggleFormFields()"
          [disabled]="webFormDetails.length >= 5"
        >
          <span [ngStyle]="{ color: isFormFieldsVisible ? 'red' : 'green' }">
            {{ isFormFieldsVisible ? "Close" : "Add Beneficiary" }}
          </span>
        </button>
      </div>
    </div>

    <div id="formFields" *ngIf="isFormFieldsVisible">
      <div class="form-group">
        <div class="col-md-12 mb-3">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label class="form-label" for="sku">sku :</mat-label>
            <input
              matInput
              formControlName="sku"
              class="form-control"
              maxlength="150"
              placeholder="SKU"
              #sku1
            />
          </mat-form-field>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-12 mb-3">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label class="form-label" for="order_item_name"
              >Order item name :</mat-label
            >
            <input
              matInput
              formControlName="order_item_name"
              class="form-control"
              maxlength="150"
              placeholder="Order item name"
              #orderitemname
            />
          </mat-form-field>
        </div>
      </div>
      <!-- <div class="form-group">
        <div class="col-md-12 mb-3">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label class="form-label" for="country">Country :</mat-label>
            <input matInput formControlName="country" class="form-control" maxlength="150" placeholder="Country"
              #orderitemname>

          </mat-form-field>
        </div>
      </div> -->
      <!-- <div class="form-group">
        <div class="col-md-12 mb-3">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label class="form-label" for="deliver_to_full_name">Deliver to full name :</mat-label>
            <input matInput formControlName="deliver_to_full_name" class="form-control" maxlength="150"
              placeholder="Deliver to full name" #delivertofullname>

          </mat-form-field>
        </div>
      </div> -->
      <div class="form-group">
        <div class="col-md-12 mb-3">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label class="form-label" for="deliver_to_first_name"
              >Deliver to first name :</mat-label
            >
            <input
              matInput
              formControlName="deliver_to_first_name"
              class="form-control"
              maxlength="150"
              placeholder="Deliver to first name"
              #delivertofirstname
            />
            <mat-error
              *ngIf="form.get('deliver_to_first_name')?.hasError('pattern')"
            >
              Only capital letters are allowed.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-12 mb-3">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label class="form-label" for="deliver_to_last_name"
              >Deliver to last name :</mat-label
            >
            <input
              matInput
              formControlName="deliver_to_last_name"
              class="form-control"
              maxlength="150"
              placeholder="Deliver to last name"
              #delivertolastname
            />
          </mat-form-field>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-12 mb-3">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label class="form-label" for="deliver_to_email"
              >Deliver to email :</mat-label
            >
            <input
              matInput
              formControlName="deliver_to_email"
              required
              class="form-control"
              maxlength="150"
              placeholder="Deliver to email"
              #delivertoemail
            />
            <mat-error *ngIf="form.get('deliver_to_email')?.hasError('email')">
              Invalid email address .
            </mat-error>
            <mat-error
              *ngIf="form.get('deliver_to_email')?.hasError('uniqueEmail')"
            >
              Email address must be unique.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-12 mb-3">
          <mat-form-field class="" appearance="outline">
            <mat-label class="form-label" for="quantity">Quantity :</mat-label>
            <input
              type="number"
              max="100"
              min="1"
              matInput
              formControlName="quantity"
              matNativeControl="number"
              class="form-control"
              maxlength="150"
              placeholder="Quantity"
              #quantity1
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div *ngIf="webFormDetails.length > 0 && !isFormFieldsVisible">
      <div class="row">
        <div class="col-md-12">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>S.No</th>
                <!-- <th>SKU</th> -->
                <th>Order Item Name</th>
                <!-- <th>Full Name</th> -->
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Quantity</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detail of webFormDetails; let i = index">
                <td>{{ i + 1 }}</td>
                <!-- <td>{{ detail.sku }}</td> -->
                <td>{{ detail.order_item_name }}</td>
                <!-- <td>{{ detail.deliver_to_full_name }}</td> -->
                <td>{{ detail.deliver_to_first_name }}</td>
                <td>{{ detail.deliver_to_last_name }}</td>
                <td>{{ detail.deliver_to_email }}</td>
                <td>{{ detail.quantity }}</td>
                <td>
                  <mat-icon
                    style="color: blue; cursor: pointer"
                    (click)="editDetail(i)"
                    ><i class="fa fa-edit" style="font-size: 20px"></i
                  ></mat-icon>
                  |
                  <mat-icon
                    style="color: black; cursor: pointer"
                    (click)="deleteDetail(i)"
                    ><i class="fa fa-trash" style="font-size: 20px"></i
                  ></mat-icon>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="form-group" *ngIf="isFormFieldsVisible">
      <div class="col-md-12 mb-3">
        <button mat-button (click)="onNoClick()">Close</button>
        <button
          mat-button
          (click)="addWebFormDetail()"
          [disabled]="form.invalid"
        >
          {{ editIndex ? "Update" : "Add" }}
        </button>
      </div>
    </div>
  </mat-dialog-actions>
</form>
